import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 80vh;

  display: flex;
  align-items: center;
  justify-content: center;
`;
